import type { PreferenceDataType, PreferenceV2 } from './preferencesV2Types';

export const normalizeValue = (dataType: PreferenceDataType, value: any) => {
  let retVal = null;
  switch (dataType) {
    case 'BOOLEAN':
      return value === 'true';
    case 'STRING':
      return value;
    case 'NUMBER':
      return Number(value);
    case 'JSON':
      if (value === null || value === 'null' || !value) {
        return {};
      }
      try {
        retVal = JSON.parse(value);
      } catch (e) {
        assert(false, e);
        return null;
      }
      return retVal;
    case 'ARRAY':
      if (value === null || value === 'null' || !value) {
        return [];
      }
      try {
        retVal = JSON.parse(value);
      } catch (e) {
        assert(false, e);
        return null;
      }
      return retVal;
    default:
      return null;
  }
};

export const isValidJSON = (input: any) => {
  let parsedInput = input;
  if (typeof input === 'string') {
    try {
      parsedInput = JSON.parse(input);
    } catch {
      return false;
    }
  }
  return typeof parsedInput === 'object' || Array.isArray(parsedInput);
};

export const convertToJSON = (value: any) => {
  if (Array.isArray(value) || typeof value === 'object') {
    return JSON.stringify(value);
  }
  return assert(false, 'Make sure you are saving an array or an object');
};

export const transformResourceValue = (resource: PreferenceV2) => {
  let savedString;
  if (resource.dataType === 'ARRAY' || resource.dataType === 'JSON') {
    return convertToJSON(resource.value);
  } else {
    savedString = String(resource.value);
  }
  return savedString;
};
